'use strict';

angular.module('mobile-apps')
	.directive('liveEditField',['$rootScope', 'focusElement', '$timeout', 'TagMain', function($rootScope, focusElement, $timeout, TagMain) {
		return {
			scope:
			{
				data: '=',
				key: '@',
				language: '@',
				category: '=',
				emptyText: '@',
				descriptionText: '@',
				changeCallback: '&',
				additionalButtons: '=',
				hideStatusBar: '@',
				deactivateClickEdit: '@',
				tagCategories:'='
			},
			templateUrl: 'modules/mobile-apps/views/live-edit-field.client.directive.html',

			link: function (scope, elem, attrs) {

				if (!scope.emptyText) {
					scope.emptyText = 'empty';
				}

				if (!scope.descriptionText) {
					scope.descriptionText = 'Enter text here...';
				}

				if (scope.deactivateClickEdit && scope.deactivateClickEdit.toLocaleUpperCase() === 'true') {
					scope.deactivateClickEdit = true;
				} else {
					scope.deactivateClickEdit = false;
				}

				scope.isActive = false;
				scope.dataCopy = scope.data;
				scope.categoryCopy = scope.category;
				
				scope.toogleCategoryMenu = function(){
					$timeout(function(){
						$('#btnTagCategorySelect').click();
					}, 33);
				}

				scope.updateSelectedCategory = function(categoryName){
					scope.categoryCopy = categoryName;
					scope.toogleCategoryMenu();
				};

				scope.getCategoryName = function(categoryName){
					if(scope.tagCategories && categoryName){
						var category = scope.tagCategories.find(function(item){ return item.name.toLowerCase() === categoryName.toLowerCase(); });
						if(category){
							return category.name;
						}
					}
					return 'None';
				};

				scope.getCategoryIcon = function(categoryName){
					if(scope.tagCategories && categoryName){
						var category = scope.tagCategories.find(function(item){ return item.name.toLowerCase() === categoryName.toLowerCase(); });
						if(category){
							return category.icon;
						}
					}
					return;
				};
				
				scope.openEdit = function($event) {
					$event.preventDefault();
					$event.stopPropagation();
					$rootScope.$broadcast('liveEditFieldActiveChanged', {
						key: scope.key,
						language: scope.language
					});
				};


				scope.closeEdit = function(saveChanges) {
					if (saveChanges && scope.changeCallback && scope.changeCallback()) {
						scope.data = scope.dataCopy;
						scope.category = scope.categoryCopy;
						if(scope.descriptionText.indexOf('tag') !== -1){
							scope.changeCallback()(scope.data, scope.key, scope.category);
						} else {
							scope.changeCallback()(scope.data, scope.key, scope.language);
						}
					}
					if($("#btnTagCategorySelect").attr("aria-expanded") !== 'false'){
						scope.toogleCategoryMenu();
					}
					scope.isActive = false;
				};


				scope.isThisEditActive = function() {
					return scope.isActive;
				};


				scope.$on('liveEditFieldActiveChanged', function (eventData, data) {
					if (data.key === scope.key && data.language === scope.language) {
						scope.isActive = true;
						scope.dataCopy = scope.data;
						scope.categoryCopy = scope.category;
						$timeout(function() {
							focusElement('editArea-' + data.key + '-' + data.language);
						}, 50);
					} else {
						scope.isActive = false;
					}

				});
			}
		};
	}]);
